import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField
} from '@mui/material'
import { useContext, useEffect, useState } from 'react'

import { GetMaintenanceScheduleTimelineIntervalTypeEnum } from '../../../sdk'
import {
  MaintenanceScheduleContext,
  SeverityType
} from './MaintenanceScheduleProvider'

export const SearchByInterval = () => {
  const {
    intervalType,
    setIntervalType,
    interval,
    setInterval,
    severityType,
    setSeverityType,
    setMaintenanceTimeline
  } = useContext(MaintenanceScheduleContext)
  const [intervalError, setIntervalError] = useState<string>('')
  useEffect(() => {
    if (interval !== undefined && interval < 0) {
      setIntervalError('Interval must be positive')
    } else if (
      interval !== undefined &&
      interval > 240 &&
      intervalType === GetMaintenanceScheduleTimelineIntervalTypeEnum.Months
    ) {
      setIntervalError(
        'The maximum allowed value for the interval Months is 240'
      )
    } else if (
      interval !== undefined &&
      interval > 300000 &&
      intervalType === GetMaintenanceScheduleTimelineIntervalTypeEnum.Miles
    ) {
      setIntervalError(
        'The maximum allowed value for the interval Miles is 300000'
      )
    } else if (
      interval !== undefined &&
      interval > 500000 &&
      intervalType === GetMaintenanceScheduleTimelineIntervalTypeEnum.Kilometers
    ) {
      setIntervalError(
        'The maximum allowed value for the interval Kilometers is 500000'
      )
    } else {
      setIntervalError('')
    }
  }, [interval, intervalType])

  return (
    <Stack
      direction="row"
      spacing={2}
      justifyContent={'flex-start'}
      alignItems={'center'}
      p={1}>
      <TextField
        variant="outlined"
        value={interval || ''}
        type="number"
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setInterval(
            event.target.value === '' ? undefined : Number(event.target.value)
          )
        }}
        error={intervalError !== ''}
        helperText={intervalError}
      />
      <FormControl>
        <FormLabel id="interval">Interval Type</FormLabel>
        <RadioGroup
          aria-labelledby="interval"
          name="interval"
          value={intervalType}
          onChange={(event) => {
            setInterval(undefined)
            setMaintenanceTimeline(undefined)
            setIntervalType(event.target.value)
          }}
          row>
          <FormControlLabel
            value={GetMaintenanceScheduleTimelineIntervalTypeEnum.Miles}
            control={<Radio />}
            label={GetMaintenanceScheduleTimelineIntervalTypeEnum.Miles}
          />
          <FormControlLabel
            value={GetMaintenanceScheduleTimelineIntervalTypeEnum.Kilometers}
            control={<Radio />}
            label={GetMaintenanceScheduleTimelineIntervalTypeEnum.Kilometers}
          />
          <FormControlLabel
            value={GetMaintenanceScheduleTimelineIntervalTypeEnum.Months}
            control={<Radio />}
            label={GetMaintenanceScheduleTimelineIntervalTypeEnum.Months}
          />
        </RadioGroup>
      </FormControl>
      <FormControl>
        <FormLabel id="severity">Severity</FormLabel>
        <RadioGroup
          aria-labelledby="severity"
          name="severity"
          value={severityType}
          onChange={(event) => {
            setSeverityType(event.target.value)
          }}
          row>
          <FormControlLabel
            value={SeverityType.Normal}
            control={<Radio />}
            label={SeverityType.Normal}
          />
          <FormControlLabel
            value={SeverityType.Severe}
            control={<Radio />}
            label={SeverityType.Severe}
          />
        </RadioGroup>
      </FormControl>
    </Stack>
  )
}
